import { createPortal } from "react-dom";
import { Upload } from "lucide-react";

type Props = {
  readonly visivel: boolean;
};

/**
 * Overlay de arrastar e soltar. Sai da moldura via portal para nao competir
 * com a sidebar (tokens --rk-z-overlay / --rk-z-modal).
 */
export function OverlaySoltarArquivos({ visivel }: Props) {
  if (!visivel || typeof document === "undefined") return null;

  return createPortal(
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-0 flex items-center justify-center p-6 motion-safe:animate-aparecer"
      style={{ zIndex: "var(--rk-z-overlay)" }}
    >
      <div
        className="absolute inset-0 bg-overlay backdrop-blur-[4px]"
        aria-hidden
      />
      <div
        className="relative w-full max-w-md space-y-3 rounded-2xl border-2 border-dashed border-primary bg-card px-8 py-12 text-center shadow-lg"
        style={{ zIndex: "var(--rk-z-modal)" }}
      >
        <div className="mx-auto flex size-14 items-center justify-center rounded-full bg-primary text-primary-foreground">
          <Upload className="size-6" aria-hidden />
        </div>
        <p className="text-xl font-semibold tracking-tight text-foreground">
          Solte para adicionar
        </p>
        <p className="text-sm text-muted-foreground">
          Entra neste projeto e fica pronto para agendar.
        </p>
      </div>
    </div>,
    document.body,
  );
}
